export default "__VITE_PUBLIC_ASSET__9a1768f9__"